import { render, staticRenderFns } from "./FooterNavStrip.vue?vue&type=template&id=e2147384"
import script from "./FooterNavStrip.vue?vue&type=script&lang=js"
export * from "./FooterNavStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports